import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store/index";
import { FavoritesContextProvider } from "./contexts/favorites-course";

render(
    <Provider store={store} >
        <FavoritesContextProvider>
            <App />
        </FavoritesContextProvider>
    </Provider>,
    document.getElementById("root"));
